import { render, staticRenderFns } from "./inbdetailsgridchange.vue?vue&type=template&id=f978e7a8"
import script from "./inbdetailsgridchange.vue?vue&type=script&lang=js"
export * from "./inbdetailsgridchange.vue?vue&type=script&lang=js"
import style0 from "./inbdetailsgridchange.vue?vue&type=style&index=0&id=f978e7a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports